const { zipCodeRegexNumeric, onlyNumeric, SPACE } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyNumeric(zipCode);
  if (zip.length <= 5) {
    return zip;
  }
  return `${zip.slice(0, 5)}-${zip.slice(5, 9)}`;
}; // 12345-1234

exports.countryDefinition = {
  country: 'Puerto Rico',
  code: 'PR',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'City', width: 0.5 },
    zipCode: {
      label: 'Zip Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', SPACE, 'zipCode']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['city', 'zipCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 characters, 12345'
    }
  ]
};
